export default "__VITE_ASSET__BZ3WCfrp__$_?react__"